export default __webpack_public_path__ + "static/media/ic-right-arrow-blue.440ef72e.svg";